<template>
<div>
  <top-menu/>
  <div class="gray-spacing"></div>
  <div class="app-view">
      <router-view :style="{width}" class="route-view" />
    <div class="gray-spacing"></div>
  </div>
  <rodape/>
</div>
</template>

<script>
import Menu from "./shared/menu/Menu";
import Rodape from "./shared/rodape/Rodape";
import { routes } from "./routes/index";
import serviceCookie from "./services/ServiceCookie";

export default {
  components: {
    "top-menu": Menu, Rodape,
  },
  name: "App",
  data() {
    return {
      scrolled: false,
      routes: routes,
      width: "",
      usuario: null,
      existeCookie: false,
      rotaAtual: "",
      width: ""
    };
  },

  //  beforeCreate() {
  //      let temCookie = serviceCookie.existe("usuario");
  //      if (!temCookie)
  //      window.location.href = "http://www.lefisc.com.br/incorrectLogin.aspx";
  //  },
  created(){
    window.addEventListener('scroll', this.handleScroll)
    console.log(this.$route.name)
    switch (this.$route.name) {
      case "Perguntas":
        this.width = "1170px";
        break;
      default:
        this.width = ""
    }
  },
  methods:{
    handleScroll(){
      this.scrolled = scrollY > 0;
    }
  },
   watch: {
    $route(to, from) {
      if(to.name == "Perguntas"){
        this.width = "1170px"
      } else {
        this.width = "";
      }
    }
   },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Aleo");
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.8.2/css/all.css");

#app {
  font-family: "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    "Noto Color Emoji";
  font-weight: normal;
  font-style: normal;
  font-size: 14px;
}

html,
body {
  background-color: #eff3f5;
  height: 100%;
}

.gray-spacing {
height: 30px;
width:100%;
background: #eff3f5;
}

.menuscrolled {
  height: 50px;
  transition: all 1s ease;
}

.route-view {
  margin: 0 auto;
  width: 1170px;
  background: #fff;
  padding-bottom: 2px;
}

.app-view {
  padding: 0;
  background: #eff3f5;
}
</style>
<style>
@keyframes exibir {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeW {
  animation-name: exibir;
  animation-direction: normal;
  animation-duration: 0.7s;
  animation-fill-mode: both;
}

body::-webkit-scrollbar {
  width: 10px;
  background: #f8f8f8;
} /* configurando scroll */

body::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.089);
}

body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #b3b3b3;
}

.transicao-pagina-enter {
  opacity: 0;
}

.transicao-pagina-enter-to {
  opacity: 1;
}

.transicao-pagina-enter-active {
  transition: opacity 1s;
}

.transicao-pagina-leave {
  opacity: 0;
}

.transicao-pagina-leave-to {
  opacity: 1;
}

.transicao-pagina-leave-active {
  transition: opacity 1s;
}
</style>
